<a class="wrapper" (click)="goBack()">
  <i class="icon-arrow-l arrow"></i>
  <p class="caption">{{viewmodel?.caption}}</p>
</a>
